<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-6">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                        </template>
                        Invoice
                    </span>
                    <p style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;

            text-transform: uppercase;
          ">
                        {{ property.contact.name }} / {{ propertyName }}
                    </p>
                </div>
            </div>
            <div class="col-6 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                        <router-link class="btn btn-table" :to="{
                  name: 'property',
                  params: { buildingId: buildingId, buildingName: buildingName },
                }"><i class="fas fa-plus"></i></router-link>-->


                    <userMenu />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 offset-md-3" style="margin-top: -10px;">

                <div class="col-12">
                    <a @click="$router.go(-1)"
                       class="btn btn-cancel"
                       style="
            width: 60px;
            display: block;
            margin-left: auto;
            margin-right: 0;
            margin-bottom: 15px;
            margin-top: -5px;
          ">Back</a>
                </div>
                <div id="element-to-convert" class="container form-background">
                    <div class="row" style="margin-left: 10px; margin-right: 10px;">
                        <div class="col-md-6" style=" display: flex; align-items: center;">
                            <h1>INVOICE</h1>
                        </div>
                        <div class="col-md-6">
                            <img :src="imageUrl" alt="avatar" style="float:right;max-width:240px;">
                        </div>


                    </div>
                    <div class="row" style="border-bottom: 1px solid #ddd; margin-left: 10px; margin-right: 10px;">
                        <div class="col-md-5">
                            <template v-if="settings.invoiceName">
                                <span>Company Name</span>
                                <span style="float:right;"><strong>{{ settings.invoiceName }}</strong></span>
                                <br />
                            </template>
                            <span>Buidling Name</span>
                            <span style="float:right;"><strong>{{ building.name }}</strong></span>
                            <br />
                            <span>Reg. No</span><br />
                            <span>Street</span><span style="float:right;"><strong>{{ building.number }} {{ building.streetName }}</strong></span><br />
                            <span>P.o Box</span><span style="float:right;"><strong>{{ building.postCode }}</strong></span><br />
                            <span>City</span><span style="float:right;"><strong>{{ building.city }}</strong></span><br />
                        </div>
                        <div class="col-md-5 offset-md-2">
                            <span>Common Expenses for </span><span style="float:right;"><strong>{{ buildingName }}</strong></span><br /><br />
                            <span>Invoice No</span> <span style="float:right;"><strong>{{ invoice.invoiceNumber }}</strong></span><br />
                            <span>Period</span> <span style="float:right;"><strong>{{invoice.month}}-{{invoice.year}}</strong></span><br />
                        </div>
                    </div>
                    <div class="row" style="border-bottom: 1px solid #ddd; margin-left: 10px; margin-right: 10px;">
                        <div class="col-md-2">
                            <span><strong>Bill To:</strong></span>
                        </div>
                        <div class="col-md-10">
                            <span>{{ property.contact.name }}</span><br />
                            <span>{{ property.floor }} / {{  property.number }} </span><br />
                        </div>
                    </div>
                    <div class="table table-responsive" style="margin-top:50px;">
                        <table class="table table-condensed">
                            <thead>
                            <th>No</th>
                            <th>Description</th>
                            <th>VAT rate</th>
                            <th>Amount</th>
                            <th>VAT</th>
                            <th>Total Amount</th>
                            </thead>
                            <tbody style="background-color: #fff;">
                                <tr v-for="invoiceItem, key in invoiceItems" class="clickable-row">
                                    <td>{{ ++key}}</td>
                                    <td>{{ invoiceItem.description}}</td>
                                    <td class="text-center">{{ $filters.toCurrency(invoiceItem.vatRate) }}</td>
                                    <td class="text-center">{{ $filters.currency(invoiceItem.netAmount, "€") }}</td>
                                    <td class="text-center">{{ $filters.currency(invoiceItem.vatAmount, "€") }}</td>
                                    <td class="text-center">{{ $filters.currency(invoiceItem.amount, "€") }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-md-6 offset-md-6">
                            <div class="right">
                                <div class="row">
                                    <div class="col-md-6 offset-md-2 pt-0 pb-0">
                                        <span class="float-right"><strong>Net Amount :</strong></span>
                                    </div>
                                    <div class="col-md-2 pt-0 pb-0">
                                        <span class="float-right">{{ $filters.currency(invoice.netAmount, "€") }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 offset-md-2 pt-0 pb-0">
                                        <span class="float-right"><strong>VAT Amount :</strong></span>
                                    </div>
                                    <div class="col-md-2 pt-0 pb-0">
                                        <span class="float-right">{{ $filters.currency(invoice.vatAmount, "€") }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 offset-md-2 pt-0 pb-0">
                                        <span class="float-right"><strong>Total Amount :</strong></span>
                                    </div>
                                    <div class="col-md-2 pt-0 pb-0">
                                        <span class="float-right">{{ $filters.currency(invoice.invoiceAmount, "€") }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    
                    <send-invoice :invoice-id="$route.params.invoiceId"/>
                    <button v-if="false" @click="cancel()" style="margin-top: 15px;" class="btn btn-submit">Send</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { format, parseISO } from "date-fns";
    import { mapState } from "vuex";
    import html2pdf from "html2pdf.js";
    export default {
        data: function () {
            return {
                id:0,
                filter: "",
                pageNumber: 0,
                invoice: {},
                invoiceItems:[],
                property: {},
                 month: 0,
                year: 0,
                contact: [],
                imageUrl:"",
                settings: {}
            };
        },
        mounted() {
            this.id = this.$route.params.invoiceId;
            this.getInvoice();
        },
        methods: {
            print() {
                html2pdf(document.getElementById("element-to-convert"), {
                    margin: 5,
                    filename: "invoice"+this.invoice.invoiceNumber+".pdf",
                });
            },
            getInvoice: function () {
                this.$http.get("/properties/invoice/" + this.id).then((response) => {
                    this.invoice = response.data.invoice,
                        this.property = response.data.property,
                        this.invoiceItems = this.invoice.invoiceItems
                    this.settings = response.data.settings
                    this.imageUrl = response.data.logo
                });
            },
        },
        computed: {
            ...mapState({
                building: (state) => state.building.currentBuilding,
                propertyName: (state) => state.property.currentPropertyName,
                propertyId: (state) => state.property.currentPropertyId,
                receiptId: (state) => state.property.currentReceiptId,
                buildings: (state) => state.building.buildings,
                numberOfAllowedBuildings: (state) =>
                    state.building.numberOfAllowedBuildings,
            }),
            buildingName() {
                if (this.building != null)
                    return this.building.name;
                return ""
            },
            buildingId() {
                if (this.building != null)
                    return this.building.id;
                return ""
            },
        },
    }
</script>